export default __webpack_public_path__ + "static/media/H&M logo.5e936f4e.svg";